function Footer() {
    return (
        <>
            <footer className="bg-black">
                <div className="container max-w-screen-sm mx-auto py-8 px-4 pb-4 text-white">
                    <section className="flex justify-between pb-8">
                        <ul className="flex flex-col items-start">
                            <li><h1 className="font-bold text-2xl">ArtByteFilip</h1></li>
                            <li className="text-neutral-400 hover:underline cursor-pointer" ><a href="https://github.com/ArtByteFilip">GitHub</a></li>
                        </ul>
                        <ul className="flex flex-col items-end text-red-500">
                            <li className="hover:underline cursor-pointer"><a href="/#aboutme">about me</a></li>
                            <li className="hover:underline cursor-pointer"><a href="/#technologies">technologies</a></li>
                            <li className="hover:underline cursor-pointer"><a href="/#projects">projects</a></li>
                            <li className="hover:underline cursor-pointer"><a href="/#contact">contact</a></li>
                        </ul>
                    </section>
                    <hr className="border-neutral-800 border-b-1 mb-4" />
                        <p className="text-base text-center text-neutral-600">© 2024 artbytefilip.eu - All rights reserved.</p>
                </div>
            </footer>
        </>
    );
}

export default Footer;